import { TileWebClient } from "../tiles.client";
import { ImageTileCodec } from "../codecs/tiles.codecs.image";
import { EPSG3857 } from "../geography/tiles.geography.EPSG3857";
import { WebTileUrlBuilder } from "../tiles.url.web";
export var GoogleMap2DLayerCode;
(function (GoogleMap2DLayerCode) {
    GoogleMap2DLayerCode["street"] = "m";
    GoogleMap2DLayerCode["satellite"] = "s";
    GoogleMap2DLayerCode["hybrid"] = "h";
    GoogleMap2DLayerCode["terrain"] = "p";
})(GoogleMap2DLayerCode || (GoogleMap2DLayerCode = {}));
export class GoogleMap2DUrlBuilder extends WebTileUrlBuilder {
    constructor(...types) {
        super();
        this.withSubDomains(["mt0", "mt1", "mt2", "mt3"])
            .withHost("{s}.google.com")
            .withPath(`vt/lyrs=${types.join(",")}&x={x}&y={y}&z={z}`)
            .withSecure(true);
    }
}
GoogleMap2DUrlBuilder.Street = new GoogleMap2DUrlBuilder(GoogleMap2DLayerCode.street);
GoogleMap2DUrlBuilder.Satellite = new GoogleMap2DUrlBuilder(GoogleMap2DLayerCode.satellite);
GoogleMap2DUrlBuilder.Hybrid = new GoogleMap2DUrlBuilder(GoogleMap2DLayerCode.satellite, GoogleMap2DLayerCode.hybrid);
GoogleMap2DUrlBuilder.Terrain = new GoogleMap2DUrlBuilder(GoogleMap2DLayerCode.terrain);
export class Google {
    static Client2d(urlBuilder, options) {
        return new TileWebClient(`${Google.KEY}_2d`, urlBuilder, new ImageTileCodec(), Google.Metrics, options);
    }
    static StreetClient2d(options) {
        return new TileWebClient(`${Google.KEY}_street2d`, GoogleMap2DUrlBuilder.Street, new ImageTileCodec(), Google.Metrics, options);
    }
    static SatelliteClient2d(options) {
        return new TileWebClient(`${Google.KEY}_sat2d`, GoogleMap2DUrlBuilder.Satellite, new ImageTileCodec(), Google.Metrics, options);
    }
    static HybridClient2d(options) {
        return new TileWebClient(`${Google.KEY}_hybrid2d`, GoogleMap2DUrlBuilder.Hybrid, new ImageTileCodec(), Google.Metrics, options);
    }
    static TerrainClient2d(options) {
        return new TileWebClient(`${Google.KEY}_terrain2d`, GoogleMap2DUrlBuilder.Terrain, new ImageTileCodec(), Google.Metrics, options);
    }
}
Google.KEY = "google";
Google.MaxLevelOfDetail = 20;
Google.Metrics = new EPSG3857({ maxLOD: Google.MaxLevelOfDetail });
Google.Attribution = "Imagery © Google";
//# sourceMappingURL=tiles.vendors.google.js.map